// Contract constants for the activity metrics admin page.
//
// These mirror the server side and must stay in step with it:
//   api/app/services/ActivityMetricsService.ts (minute classification,
//   rollup shape)

// Active and present minutes are a UNION of distinct client_event_at minute
// buckets across the sde_v2 and sde_v2_viewer surfaces, never a sum. A user with
// both tabs open occupies one minute, not two, so per-user and per-surface
// breakdowns can legitimately add up to more than the overall figure. Shown in
// the UI wherever a breakdown sits next to its total.
export const UNION_CAVEAT =
	"Active and present minutes are a union of distinct minute buckets across surfaces, never a sum. Per-user and per-surface rows can therefore add up to more than the overall total.";

// Default date-filter window, in local calendar days including today.
export const DEFAULT_FILTER_DAYS = 14;

// Local YYYY-MM-DD for a Date, from LOCAL date parts. Never
// toISOString().slice(0, 10): that is the UTC day, which shifts the calendar
// day for any user west of Greenwich in the evening.
export function toLocalDateString(date) {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
}

// The default filter window: today back through DEFAULT_FILTER_DAYS - 1 days
// ago, as local calendar days (what the pickers hold).
export function defaultDateRange() {
	const today = new Date();
	const start = new Date();
	start.setDate(today.getDate() - (DEFAULT_FILTER_DAYS - 1));
	return {
		startDate: toLocalDateString(start),
		endDate: toLocalDateString(today),
	};
}

// The pickers hold local calendar days; the API gets exact instants so the
// server never guesses a timezone (bare-date params bind against UTC there,
// which cut ranges ending "today" off at 5pm PT - the bug that got the first
// date filter removed). Parse the Y/M/D parts NUMERICALLY: new
// Date("YYYY-MM-DD") parses as UTC midnight, the exact bug class this
// module exists to kill.
export function toLocalDayStartIso(dateStr) {
	const [year, month, day] = dateStr.split("-").map(Number);
	return new Date(year, month - 1, day, 0, 0, 0, 0).toISOString();
}

export function toLocalDayEndIso(dateStr) {
	const [year, month, day] = dateStr.split("-").map(Number);
	return new Date(year, month - 1, day, 23, 59, 59, 999).toISOString();
}
